import * as am5 from '@amcharts/amcharts5';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

/** Drop any previously registered Angular SW so offline refresh no longer serves a cached shell. */
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      void registration.unregister();
    }
  });
}

const amChartsKey = environment.amChartsLicenseKey;
if (typeof amChartsKey === 'string' && amChartsKey.trim()) {
  am5.addLicense(amChartsKey.trim());
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
